import { OneThousandActualWords } from "./OneThousandActualWords"
// import { TwoThousandActualWords } from "./TwoThousandActualWords"

export const OneThousand = OneThousandActualWords.map((value, index) => ({
    id: index + 1,
    word: value.word,
    word_context: value.word_context,
    translat: value.translat,
    dictionary: value.dictionary,
    translat_context: value.translat_context,
    display_translat: "hidden",
    visibility_translate: "hidden",
    display_word: "block",
    tobeChecked: false,
    correctTutor: false,
    correctStudent: false,
    input: "",
}))
